export default "__VITE_ASSET__WkF6usJq__"